import React, { useState } from 'react';
import useToggle from '../../../custom_hooks/useToggle';

const upArrow = (
    <div className="relative">
        <div
            style={{
                width: '1rem',
                height: '0.125rem',
                background: '#141711',
                position: 'absolute',
                right: '.5rem'
            }}
        ></div>
    </div>
);

const downArrow = (
    <div className="relative">
        <div
            style={{
                width: '1rem',
                height: '0.125rem',
                background: '#141711',
                transform: 'rotate(90deg)',
                position: 'absolute',
                right: '.5rem'
            }}
        ></div>
        <div
            style={{
                width: '1rem',
                height: '0.125rem',
                background: '#141711',
                position: 'absolute',
                right: '.5rem'
            }}
        ></div>
    </div>
);

const faqsItems = [
    {
        id: 1,
        header: 'What is Chamify?',
        text: `Chamify is a user-friendly platform that helps individuals and groups save, and soon invest and access loans, all in one place. Whether you're saving on your own or with a chama, Chamify makes it easier to achieve your financial goals by providing a secure and convenient way to manage your money.`,
    },
    {
        id: 2,
        header: 'Can I integrate with M-PESA?',
        text: 'Yes. Chamify integrates with M-PESA, allowing you to make deposits and withdrawals conveniently using your mobile phone. Transactions are secure, seamless, and designed to make managing your savings simple.',
    },
    {
        id: 3,
        header: 'How does group saving work?',
        text: `With Chamify, you can create or join a savings group (chama) and contribute based on your group's agreed schedule. The platform automatically tracks contributions, sends payment reminders, and keeps transparent records for all members, making group savings easier, more organized, and more accountable.`,
    },
    {
        id: 4,
        header: 'Will Chamify support investing?',
        text: 'Yes. This feature is coming soon. Chamify will enable members to invest in Money Market Funds (MMFs) directly through the app, making it easy to grow their savings while managing everything from one platform. Stay tuned for this exciting addition.',
    },
    {
        id: 5,
        header: 'Are there any fees?',
        text: 'Creating an account and saving on Chamify is free. Withdrawal charges apply and are based on the standard M-PESA withdrawal rates. Any applicable charges are displayed before you complete your transaction, ensuring full transparency.',
    },
];

export default function FAQsComponent() {
    const { show, toggle } = useToggle(true);

    const [activeId, setactiveId] = useState(1);

    function handleActiveId(val) {
        setactiveId(val);
        if (show) {
            return;
        }
        toggle();
    }

    return (
        <>
            <div className="w-full flex flex-col items-center justify-center">
                <span className="lanidng_faq_header">Frequently asked questions</span>

                <div className="mt-[3.12rem] w-full">
                    {faqsItems.map((item) => {
                        return (
                            <div className="w-full" key={item.id}>
                                <button onClick={() => handleActiveId(item.id)} className="w-full flex justify-between items-center mb-[1.25rem]">
                                    <span className="lanidng_faq_faq_header w-[90%] text-left">{item.header}</span>
                                    {show && activeId === item.id ? upArrow : downArrow}
                                </button>
                                {show && activeId === item.id ? <span className="lanidng_faq_faq_txt">{item.text}</span> : null}
                                <div className="w-full h-[.0625rem] bg-[#D9DAD7] mt-[1.88rem] mb-[2.06rem]"></div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
}
